import useWindowSize from "../../../../hooks/useWindowSize";
import { func } from "../../../../utils";
import { Wrapper } from "./TrainingCampSoc.styled";

const TrainingCampSoc = ({ KV, mobileKV }) => {
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 830;

  return (
    <div className="relative">
      <Wrapper
        id="training-camp"
        backgroundImage={func.getStaticImg(
          isMobileView
            ? "illustration/trainingcamp2025-soc-bg-m.png"
            : "illustration/trainingcamp2025-soc-bg.png",
        )}
      >
        <img
          className={`absolute md:right-0 ${
            isMobileView ? "top-[55svh]" : "bottom-0"
          } z-[1] center w-[100%]`}
          // src={isMobileView ? mobileKV : KV}
          // temporary
          src={func.getStaticImg(
            isMobileView
              ? "illustration/trainingcampclub2025-m.png"
              : "illustration/trainingcampclub2025.png",
          )}
        />
        <div
          className="flex flex-col justify-between h-screen w-full z-[2]"
          style={{
            background: isMobileView
              ? "linear-gradient(359deg, rgb(31, 45, 61) 0.47%, rgba(31, 45, 61, 0) 7.66%)"
              : "",
          }}
        >
          <div className="flex flex-row w-[327px] md:w-[1160px] mx-auto mt-48 md:my-auto">
            <div className="flex flex-col max-w-[480px]">
              <p className="text-white font-semibold text-[13px] md:text-[20px] mb-6">
                12 PLAYERS TURN DREAMS INTO PRO CLUB TRYOUTS
              </p>
              <img
                src={func.getStaticImg(
                  isMobileView
                    ? "typography/trainingcamp2025-title-m.png"
                    : "typography/trainingcamp2025-title.png",
                )}
                // style={{ position: "relative", left: -65 }}
                className="relative left-[-25px] md:left-[-65px]"
              />
              <p className="text-white text-2xl md:text-[18px]  mt-8 md:mt-12">
                Dari 50 talenta muda terpilih, hanya 12 yang akan melakukan tryout bersama tiga klub
                raksasa nasional.
              </p>
              <p className="text-white text-2xl md:text-[18px]  mt-6 md:mt-8">
                Satu langkah menuju pemain futsal pro!
              </p>
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};
export default TrainingCampSoc;
